<template>
  <div class="box-tab-content">
      <div class="active"><span v-for="item in cardList" :key="item.activeType" @click="handleChangeCard(item)" :class="[isActiveType === item.activeType ? 'selected' : '' ]">{{item.name}}</span></div>
      <div class="active_wrap" v-if="isActiveType === 1">
        <el-card class="box-card">
          <div slot="header" class="clearfix"><span>收款汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalGunAmount || 0}}</span><span>{{isGas === 2 ? '金额' : '加油金额'}}</span></div>
            <!-- <el-popover
              class="pop"
              style="width: 100%"
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div class="pop-des">商家承担直降金额：{{czbGasDutyRecor.amountActivityMerchant || 0}}</div>
                <div class="pop-des">商家承担平台优惠券金额：{{czbGasDutyRecor.amountPlatformCouponMerchant || 0}}</div>
                <div class="pop-des">商家承担商家优惠券金额：{{czbGasDutyRecor.merchantCouponAmount || 0}}</div>
                <div class="pop-des">平台让利金额：{{czbGasDutyRecor.platformProfitAmount || 0}}</div>
              </div>
              <div class="word g-flx-center"  slot="reference">
                <span>{{czbGasDutyRecor.preferentialAmount || 0}}</span><span>优惠金额汇总</span>
              </div>
            </el-popover> -->
            <div class="word g-flx-center" v-if="isShowReal"><span>{{czbGasDutyRecord.totalRealPayAmount || 0}}</span><span>实付金额汇总</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.orderCount || 0}}</span><span>{{isGas === 2 ? '加气笔数' : '加油笔数'}}</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalLitre || 0}}</span><span>{{isGas === 2 ? '加气数量' : '加油升数'}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix"><span>退款汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalRefundAmount || 0}}</span><span>退款金额</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.refundCount || 0}}</span><span>退款笔数</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalRefundLitre || 0}}</span><span>{{isGas === 2 ? '退款数量' : '退款升数'}}</span></div>
          </div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.periodRefundAmount || 0}}</span><span class="word-break">{{ platformName }}当班退款金额</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.periodRefundCount || 0}}</span><span>{{ platformName }}当班退款笔数</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.periodRefundLitre || 0}}</span><span>{{isGas === 2 ? `${platformName}当班退款数量` : `${platformName}当班退款升数`}}</span></div>
          </div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.otherRefundAmount || 0}}</span><span>{{ platformName }}非当班退款金额</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.otherRefundCount || 0}}</span><span>{{ platformName }}非当班退款笔数</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.otherRefundLitre || 0}}</span><span>{{isGas === 2 ? `${platformName}非当班退款数量` : `${platformName}非当班退款升数`}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card" v-if="isShowSum">
          <div slot="header" class="clearfix"><span>结算汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalSettlement || 0}}</span><span>应结算金额</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.totalChannelFee || 0}}</span><span>通道费金额</span></div>
            <div class="word g-flx-center"><span>{{czbGasDutyRecord.platformProfitAmount || 0}}</span><span>平台让利</span></div>
            <el-popover
              class="pop"
              style="width: 100%"
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div class="pop-des">商家承担直降金额：{{czbGasDutyRecord.amountActivityMerchant || 0}}</div>
                <div class="pop-des">商家承担平台优惠券金额：{{czbGasDutyRecord.amountPlatformCouponMerchant || 0}}</div>
                <div class="pop-des">商家承担商家优惠券金额：{{czbGasDutyRecord.merchantCouponAmount || 0}}</div>
                <div class="pop-des">商家权益卡优惠金额：{{czbGasDutyRecord.mctProfitMctAmount || 0}}</div>
              </div>
              <div class="word g-flx-center" slot="reference">
                <span>{{czbGasDutyRecord.preferentialMerchantsAmount || 0}}</span><span>商家优惠金额</span>
              </div>
            </el-popover>
          </div>
          <div class="active_count" style="justify-content: flex-start">
            <div class="word g-flx-center" style="width: 25%"><span>{{czbGasDutyRecord.totalRealSettlement || 0}}</span><span>实际结算金额</span></div>
          </div>
        </el-card>
      </div>
      <div class="active_wrap" v-if="isActiveType === 2">
         <el-card class="box-card">
          <div slot="header" class="clearfix"><span>{{ platformName }}收单收款汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalGunAmount || 0}}</span><span>{{isGas === 2 ? '金额' : '加油金额'}}</span></div>
            <!-- <el-popover
              class="pop"
              style="width: 100%"
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div class="pop-des">商家承担直降金额：{{appCzbGasDuty.amountActivityMerchant || 0}}</div>
                <div class="pop-des">商家承担平台优惠券金额：{{appCzbGasDuty.amountPlatformCouponMerchant || 0}}</div>
                <div class="pop-des">商家承担商家优惠券金额：{{appCzbGasDuty.merchantCouponAmount || 0}}</div>
                <div class="pop-des">平台让利金额：{{appCzbGasDuty.platformProfitAmount || 0}}</div>
              </div>
              <div class="word g-flx-center"  slot="reference">
                <span>{{appCzbGasDuty.preferentialAmount || 0}}</span><span>优惠金额汇总</span>
              </div>
            </el-popover> -->
            <div class="word g-flx-center" v-if="isShowReal"><span>{{appCzbGasDuty.totalRealPayAmount || 0}}</span><span>实付金额汇总</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.orderCount || 0}}</span><span>{{isGas === 2 ? '加气笔数' : '加油笔数'}}</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalLitre || 0}}</span><span>{{isGas === 2 ? '加气数量' : '加油升数'}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix"><span>退款汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalRefundAmount || 0}}</span><span>退款金额</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.refundCount || 0}}</span><span>退款笔数</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalRefundLitre || 0}}</span><span>{{isGas === 2 ? '退款数量' : '退款升数'}}</span></div>
          </div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{appCzbGasDuty.periodRefundAmount || 0}}</span><span class="word-break">{{ platformName }}当班退款金额</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.periodRefundCount || 0}}</span><span>{{ platformName }}当班退款笔数</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.periodRefundLitre || 0}}</span><span>{{isGas === 2 ? `${platformName}当班退款数量` : `${platformName}当班退款升数`}}</span></div>
          </div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{appCzbGasDuty.otherRefundAmount || 0}}</span><span>{{ platformName }}非当班退款金额</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.otherRefundCount || 0}}</span><span>{{ platformName }}非当班退款笔数</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.otherRefundLitre || 0}}</span><span>{{isGas === 2 ? `${platformName}非当班退款数量` : `${platformName}非当班退款升数`}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card" v-if="isShowSum">
          <div slot="header" class="clearfix"><span>结算汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalSettlement || 0}}</span><span>应结算金额</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.totalChannelFee || 0}}</span><span>通道费金额</span></div>
            <div class="word g-flx-center"><span>{{appCzbGasDuty.platformProfitAmount || 0}}</span><span>平台让利</span></div>
            <el-popover
              class="pop"
              style="width: 100%"
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div class="pop-des">商家承担直降金额：{{appCzbGasDuty.amountActivityMerchant || 0}}</div>
                <div class="pop-des">商家承担平台优惠券金额：{{appCzbGasDuty.amountPlatformCouponMerchant || 0}}</div>
                <div class="pop-des">商家承担商家优惠券金额：{{appCzbGasDuty.merchantCouponAmount || 0}}</div>
                <div class="pop-des">商家权益卡优惠金额：{{appCzbGasDuty.mctProfitMctAmount || 0}}</div>
              </div>
              <div class="word g-flx-center" slot="reference">
                <span>{{appCzbGasDuty.preferentialMerchantsAmount || 0}}</span><span>商家优惠金额</span>
              </div>
            </el-popover>
          </div>
          <div class="active_count" style="justify-content: flex-start">
            <div class="word g-flx-center" style="width: 25%"><span>{{appCzbGasDuty.totalRealSettlement || 0}}</span><span>实际结算金额</span></div>
          </div>
        </el-card>
      </div>
      <div class="active_wrap" v-if="isActiveType === 3">
         <el-card class="box-card">
          <div slot="header" class="clearfix"><span>POS收单汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalGunAmount || 0}}</span><span>{{isGas === 2 ? '金额' : '加油金额'}}</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.orderCount || 0}}</span><span>{{isGas === 2 ? '加气笔数' : '加油笔数'}}</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalLitre || 0}}</span><span>{{isGas === 2 ? '加气数量' : '加油升数'}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix"><span>退款汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalRefundAmount || 0}}</span><span>退款金额</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.refundCount || 0}}</span><span>退款笔数</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalRefundLitre || 0}}</span><span>{{isGas === 2 ? '退款数量' : '退款升数'}}</span></div>
          </div>
        </el-card>
        <el-card class="box-card" v-if="isShowSum">
          <div slot="header" class="clearfix"><span>结算汇总</span></div>
          <div class="active_count">
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalSettlement || 0}}</span><span>应结算金额</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalChannelFee || 0}}</span><span>通道费金额</span></div>
            <div class="word g-flx-center"><span>{{posCzbGasDuty.totalRealSettlement || 0}}</span><span>实际结算金额</span></div>
          </div>
        </el-card>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    czbGasDutyRecord: {
      type: Object
    },
    appCzbGasDuty: {
      type: Object
    },
    posCzbGasDuty: {
      type: Object
    },
    isShowSum: {
      type: Boolean
    },
    isShowReal: {
      type: Boolean
    },
    isGas: {
      type: Number
    },
    modelActiveType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isActiveType: 1, // 全部汇总-1 团油收单汇总-2 POS收单汇总-5
      cardList: [
        { name: '全部汇总', activeType: 1, interestCode: 'all' },
        { name: '油品收单汇总', activeType: 2, interestCode: 'tuan' },
        { name: 'POS收单汇总', activeType: 3, interestCode: 'pos' }
      ],
      // isSdLogin: JSON.parse(sessionStorage.getItem('isSdLogin'))
    }
  },
  watch: {
    modelActiveType(newVal) {
      if (newVal === 3) this.cardList = this.cardList.filter(item => item.activeType !== 3)
      else {
        const index = this.cardList.findIndex(item => item.activeType === 3)
        if (index === -1) this.cardList.push({ name: 'POS收单汇总', activeType: 3, interestCode: 'pos' })
      }
    }
  },
  computed: {
    ...mapGetters(['platformName'])
  },
  methods: {
    // 切换活动类型卡片
    handleChangeCard ({ activeType }) {
      if (activeType === 2) {
        this.$track.clickEvent('交接班操作团油收单汇总', '1621476221')
      } else if (activeType === 3) {
        this.$track.clickEvent('交接班操作POS收单汇总', '1621476222')
      }
      this.isActiveType = activeType
    },
  }
}
</script>
<style scoped lang="less">
  .box-tab-content{
    position: relative;
    overflow: hidden;
    .active{
      position: absolute;
      top: 1px;
      z-index: 10;
      >span{
        display: inline-block;
        width: 130px;
        height: 40px;
        font-size:16px;
        font-family: PingFangSC-Bold, PingFang SC;
        margin-right: 5px;
        border:1px solid #DCDFE6;
        border-radius: 15px 15px 0 0;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
      .selected{
        background: #fff;
        color: #000;
        border-bottom: none;
      }
    }
    .active_wrap{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 30px 10px;
      margin-top: 40px;
      white-space: nowrap;
      overflow-x: auto;
      border:1px solid #DCDFE6;
      background: #fff;
      .box-card{
        height: 300px;
        width: 30%;
        min-width: 375px;
        margin: 0 20px;
        .active_count{
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          .pop{
            cursor: pointer;
            .pop-des{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #383838;
              line-height: 25px;
            }
          }
          .word{
            >span:nth-child(1){
              color: #4B7FFC;
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            >span:nth-child(2){
              width: 70%;
              color: #909399;
              font-size: 14px;
              margin-bottom: 10px;
              white-space: pre-wrap;
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>